<template lang="pug">
.p-5.mb-8
  .mx-4.p-4
    .steps
      template(v-for="step in steps")
        .step(:class="{ done: step.position < position, active: step.position === position }")
          .point
            font-awesome-icon(v-if="step.icon" :icon="step.icon")
          .label {{ step.label }}
        .way(v-if="step.position < steps.length" :class="{ done: step.position < position }")
</template>

<script>
export default {
    name: 'Steps',
    props: {
        steps: {
            type: Array,
            required: true
        },
        position: {
            type: Number,
            default: 0
        }
    }
};
</script>

<style lang="sass">
.steps
  @apply flex items-center
  .step
    @apply flex items-center text-gray-500 relative
    &.active
      @apply text-white
      .point
        // @apply bg-blue-600 border-blue-600
        background: var(--color-primary)
        border-color: var(--color-primary)
        // --switch:calc((var(--primary-color-l) - var(--contrastThreshold)) * -100)
        // color: hsl(0, 0%, var(--switch))
      .label
        // @apply text-blue-600
        color: var(--color-primary)
    &.done
      // @apply text-blue-600
      color: var(--color-primary)
      .point
        // @apply border-blue-600
        border-color: var(--color-primary)
      .label
        // @apply text-blue-600
        color: var(--color-primary)
    .point
      @apply flex items-center justify-center text-lg rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 border-gray-300
    .label
      @apply absolute top-0 -ml-10 text-center mt-16 w-32 text-xs font-medium uppercase text-gray-500
  .way
    @apply flex-auto border-t-2 transition duration-500 ease-in-out border-gray-300
    &.done
      // @apply border-blue-600
      border-color: var(--color-primary)
</style>
